import { BaseConnector } from '@/modules/api/BaseConnector';
import { API_TIMEOUTS } from '../constant';
import { IMicrosoftGraphConnector } from '@/modules/api/MicrosoftGraphConnector/IMicrosoftGraphConnector';

export class MicrosoftGraphConnector extends BaseConnector implements IMicrosoftGraphConnector {
  private static instance: MicrosoftGraphConnector;
  private static baseUrl = 'https://graph.microsoft.com/v1.0';
  private static scopes = ['user.read', 'profile'];

  public static getInstance(): IMicrosoftGraphConnector {
    if (!MicrosoftGraphConnector.instance) {
      MicrosoftGraphConnector.instance = new MicrosoftGraphConnector();
    }
    return MicrosoftGraphConnector.instance;
  }

  private constructor() {
    super(
      MicrosoftGraphConnector.baseUrl,
      MicrosoftGraphConnector.scopes,
      API_TIMEOUTS.microsoftGraph,
    );
  }

  async getUserAvatar(): Promise<Blob | undefined> {
    return this.get<Blob>('/me/photo/$value', {
      skipLatest: true,
      config: {
        responseType: 'blob',
      },
    });
  }
}
